import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type StateType = {
  callBackUrl: string;
  isShowCaptchaInLogin: boolean;
  hasFinger: boolean;
  showLoginWithBrokersSSO:boolean;
};

const initialState: StateType = {
  callBackUrl: '',
  isShowCaptchaInLogin: false,
  hasFinger: false,
  showLoginWithBrokersSSO:false
};

export const autorizationSlice = createSlice({
  name: 'autorization',
  initialState,
  reducers: {
    callBackUrlSaveAction: (state, { payload }: PayloadAction<string>) => {
      state.callBackUrl = payload;
    },
    isShowCaptchaInLoginAction: (
      state,
      { payload }: PayloadAction<{ showCaptcha: boolean; hasFinger: boolean,showLoginWithBrokersSSO:boolean }>
    ) => {
      state.isShowCaptchaInLogin = payload.showCaptcha;
      state.hasFinger = payload.hasFinger;
	  state.showLoginWithBrokersSSO = payload.showLoginWithBrokersSSO
    },
  },
});

export const { callBackUrlSaveAction, isShowCaptchaInLoginAction } =
  autorizationSlice.actions;

export default autorizationSlice.reducer;
